import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FormBlock } from "./FormBlock";
import { defaultData } from "./FormBlockDefaultData";
import { meta } from "./FormBlockMetaData";

export const FormBlockExport: BlockExport = {
  type: "component",
  Block: FormBlock,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-contacts",
    size: 24,
  },
  defaultData,
  meta,
};
